// extracted by mini-css-extract-plugin
module.exports = {"grid":"_2fB6-","header":"WCrT-","specifications":"S75Mu","remove":"_35WuB"};